// @ts-nocheck
import React from 'react';
import intl from 'react-intl-universal';
import { MenuItem, Button, Tag } from '@blueprintjs/core';
import { MultiSelect } from '@blueprintjs/select';
import { FormattedMessage as T } from '@/components';
import classNames from 'classnames';
import { CLASSES } from '@/constants/classes';

const FundSelectMulti = MultiSelect.ofType();

/**
 * Fund multi select field.
 */
export function FundMultiSelect({
  funds,
  selectedFundIds = [],
  defaultSelectText = intl.get('select_funds'),
  popoverFill = false,
  onChange,
  ...multiSelectProps
}) {
  // Get selected funds from IDs
  const selectedFunds = React.useMemo(
    () => funds.filter((f) => selectedFundIds.includes(f.id)),
    [funds, selectedFundIds]
  );

  /**
   * Renders the fund item.
   */
  const fundItemRenderer = (fund, { handleClick, modifiers }) => {
    return (
      <MenuItem
        disabled={modifiers.disabled}
        label={fund.code}
        key={fund.id}
        onClick={handleClick}
        text={fund.name}
        selected={selectedFundIds.includes(fund.id)}
      />
    );
  };

  /**
   * Predicate for filtering funds.
   */
  const fundItemPredicate = (query, fund) => {
    const normalizedTitle = fund.name.toLowerCase();
    const normalizedQuery = query.toLowerCase();
    return `${fund.code}. ${normalizedTitle}`.indexOf(normalizedQuery) >= 0;
  };

  /**
   * Handles fund selection.
   */
  const handleFundSelect = React.useCallback(
    (fund) => {
      const newSelectedFunds = selectedFundIds.includes(fund.id)
        ? selectedFunds.filter((f) => f.id !== fund.id)
        : [...selectedFunds, fund];
      
      onChange?.(newSelectedFunds);
    },
    [selectedFunds, selectedFundIds, onChange]
  );

  /**
   * Renders the tag for each selected fund.
   */
  const tagRenderer = (fund) => {
    return fund.name;
  };

  /**
   * Handles removing a fund.
   */
  const handleTagRemove = (fund, index) => {
    const newSelectedFunds = selectedFunds.filter((f) => f.id !== fund.id);
    onChange?.(newSelectedFunds);
  };

  /**
   * Handles clearing all selected funds.
   */
  const handleClear = React.useCallback(() => {
    onChange?.([]);
  }, [onChange]);

  return (
    <FundSelectMulti
      items={funds}
      itemRenderer={fundItemRenderer}
      itemPredicate={fundItemPredicate}
      onItemSelect={handleFundSelect}
      tagRenderer={tagRenderer}
      selectedItems={selectedFunds}
      tagInputProps={{
        onRemove: handleTagRemove,
        placeholder: defaultSelectText,
        rightElement: selectedFunds.length > 0 && (
          <Button minimal={true} icon="cross" onClick={handleClear} />
        ),
      }}
      popoverProps={{ minimal: true, boundary: 'window' }}
      fill={true}
      resetOnSelect={true}
      className={classNames(CLASSES.FORM_GROUP_LIST_SELECT, {
        [CLASSES.SELECT_LIST_FILL_POPOVER]: popoverFill,
      })}
      {...multiSelectProps}
    />
  );
} 